import createPersistedState from 'vuex-persistedstate';
var state = {
  currentState: 'YzPhone',
  // 当前步骤
  currentLoginType: 'phone',
  // 当前登录类型
  isQrLogin: true,
  // 是否是二维码登录
  pswData: '',
  // 密码验证返回的信息
  userData: '',
  // 帐号验证返回的信息
  userMobile: '',
  // 找回密码用户手机号信息
  loginInfo: '',
  // 登录的数据
  protocolVisible: false,
  privacyVisible: false,
  ruleState: false,
  // 密码规则
  url: '',
  domains: [],
  wudomain: '',
  buttjoint: {} // 忘记密码接入方

};
var mutations = {
  SET_RETRIEVESTEP: function SET_RETRIEVESTEP(state, params) {
    state.currentState = params;
  },
  SET_QRLOGIN: function SET_QRLOGIN(state, bool) {
    state.isQrLogin = bool;
  },
  SET_LOGINTYPE: function SET_LOGINTYPE(state, params) {
    state.currentLoginType = params;
  },
  SET_PSWDATA: function SET_PSWDATA(state, params) {
    state.pswData = params;
  },
  SET_USERDATA: function SET_USERDATA(state, params) {
    state.userData = params;
  },
  SET_USERMOBILE: function SET_USERMOBILE(state, params) {
    state.userMobile = params;
  },
  SET_LOGININFO: function SET_LOGININFO(state, params) {
    state.loginInfo = params;
  },
  SET_RULESTATE: function SET_RULESTATE(state, params) {
    state.ruleState = params;
  },
  SET_RUL: function SET_RUL(state, params) {
    state.url = params;
  },
  SET_DOMAINS: function SET_DOMAINS(state, params) {
    state.domains = params;
  },
  SET_WODOMAIN: function SET_WODOMAIN(state, params) {
    state.wudomain = params;
  },
  SET_BUTTJOINT: function SET_BUTTJOINT(state, params) {
    state.buttjoint = params;
  },
  SET_PROTOCOL: function SET_PROTOCOL(state, params) {
    state.protocolVisible = params;
  },
  SET_PRIVACY: function SET_PRIVACY(state, params) {
    state.privacyVisible = params;
  }
};
var actions = {};
var plugins = [createPersistedState({
  storage: window.sessionStorage,
  reducer: function reducer(val) {
    return {
      currentState: val.currentState,
      currentLoginType: val.currentLoginType,
      userData: val.userData,
      loginInfo: val.loginInfo,
      pswData: val.pswData,
      url: val.url,
      domains: val.domains,
      wudomain: val.wudomain,
      buttjoint: val.buttjoint
    };
  }
})];
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  plugins: plugins
};